// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__H1g1h","spinner":"LoadingSpinner_spinner__bvL3y","prwSpinner":"LoadingSpinner_prwSpinner__PQJhu","label":"LoadingSpinner_label__L8vgQ"};